import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Typography } from '@beeline/design-system-react/extracted-styles';

import { getAdminState } from 'src/store/admin/selectors';
import { PlaceType } from 'src/types';

import { labelsByBookingObjectType } from '../consts';
import { toBookingObjectType } from '../utils';

export const AdminSidesheetTitle: FC = () => {
  const { selectedPlace } = useSelector(getAdminState);

  const title = useMemo((): string => {
    if (!selectedPlace) return 'Объект бронирования';

    return labelsByBookingObjectType[
      toBookingObjectType(
        selectedPlace.type,
        selectedPlace.type === PlaceType.Room
          ? selectedPlace.roomType
          : undefined,
      )
    ];
  }, [selectedPlace]);

  return (
    <Typography variant='h5' data-testid='administratorSideSheetTitle'>
      {title}
    </Typography>
  );
};
